// Saved settings retain their actual controls; null is distinct from false.
import { type ReactNode } from 'react';

import { SettingsRow } from '@apps/web/components/settings/settings_primitives';
import { Switch } from '@apps/web/components/ui/switch';
import { type WriteResultPresentation } from '@apps/web/features/phoebe_chat_v3/registry/types';
import { ActionResultCard } from '@apps/web/features/phoebe_chat_v3/ui/primitives/action_result_card';
import settingsFieldLabels from '@libraries/python/organization_settings_schemas/settings_field_labels.json';

export function SettingsReceiptCard({
    receipt,
}: Readonly<{ receipt: WriteResultPresentation }>): ReactNode {
    return (
        <ActionResultCard
            status={receipt.status ?? 'succeeded'}
            title={receipt.title}
            summary={receipt.summary}
            notices={receipt.notices}
        >
            <div className="divide-y">
                {Object.entries(receipt.settingsChanges ?? {}).flatMap(
                    ([key, change]) => {
                        const label: unknown =
                            Object.prototype.hasOwnProperty.call(
                                settingsFieldLabels,
                                key,
                            )
                                ? settingsFieldLabels[
                                      key as keyof typeof settingsFieldLabels
                                  ]
                                : undefined;
                        if (typeof label !== 'string') {
                            return [];
                        }
                        const title =
                            label.charAt(0).toUpperCase() + label.slice(1);
                        return [
                            <SettingsRow
                                key={key}
                                title={title}
                                className="[&_label]:text-v3-chat px-0 py-2 last:pb-0 [&_label]:leading-(--text-v3-chat--line-height)"
                                control={
                                    typeof change.to === 'boolean' ? (
                                        <Switch
                                            aria-label={title}
                                            checked={change.to}
                                            disabled={true}
                                            className="disabled:opacity-100"
                                        />
                                    ) : (
                                        <span className="text-v3-chat tabular-nums">
                                            {change.to === null
                                                ? 'Not set'
                                                : change.to}
                                        </span>
                                    )
                                }
                            />,
                        ];
                    },
                )}
            </div>
        </ActionResultCard>
    );
}
